export const STEP_STATUS = {
    Coming: 'COMING',
    Active: 'ACTIVE',
    Checked: 'CHECKED',
} as const;

export type StepStatusType = (typeof STEP_STATUS)[keyof typeof STEP_STATUS];

export interface StepProps {
    status: StepStatusType;
    stepNumber: number;
}

export interface StepperProps {
    stepsNumber: number;
    activeStep: number;
    stepLabels?: string[];
    className?: string;
}
